import React from 'react';
import { requestHelpers } from '../../../helpers';
import Anchor from "../../dashboardNew/objects/Anchor";
import { camelCase } from './../../../helpers/common/stringUtils';
import { getField, validate, isValid } from './../../../helpers/common/form';

export class ContactPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            sent    : false,
            fields  : [
                {
                    tagName         : "input",
                    name            : "first-name",
                    type            : "text",
                    label           : "First Name",
                    placeholder     : "John", 
                    required        : true
                },
                {
                    tagName         : "input",
                    name            : "last-name",
                    type            : "text",
                    label           : "Last Name",
                    placeholder     : "Smith", 
                    required        : true
                },
                {
                    tagName         : "input",
                    name            : "email",
                    type            : "email",
                    label           : "Email",
                    placeholder     : "JohnSmith@example.com", 
                    required        : true
                },
                {
                    tagName         : "input",
                    name            : "phone-number",
                    type            : "number",
                    label           : "Phone Number",
                    placeholder     : "***********", 
                    required        : true
                },
                {
                    tagName         : "textarea",
                    name            : "message",
                    type            : "text",
                    label           : "Message",
                    placeholder     : "What can we help you with...?", 
                    required        : true,
                    classOveride    : "col-12 form-group alt"
                }
            ]
        };

        this.formRef = React.createRef();
    }

    onBlurValueValidate = ( evt, type, name ) => this.setState({ fields : [ ...validate( evt, type, name, this.state.fields ) ] });

    buildFields = () => this.state.fields.map( field => getField( field, this.onBlurValueValidate ) )

    submit(){

        let fields;
        var condition = isValid( this.state.fields );
        var condition2;
        
        if( condition ){
            let fields;
            this.state.fields.forEach( field => {
                fields = [ ...validate( { target : { value : this.formRef.current.querySelector( `#${ field.name }` ).value } }, field.type, field.name, this.state.fields ) ];
            });
            condition2 = isValid( fields );
            if( condition2 ){ return this.setState({ fields }) };
        };

        const send = () => {

            const body = {};
            this.state.fields.forEach( item => { body[ camelCase( item.name ) ] = item.value });
            body.person_id = window.localStorage.getItem( 'person_id' );
            body.isUK = window.localStorage.getItem('site_of_origin') === 'gb';

            requestHelpers
                .unauthenticatedPostRequest( '/communications/contact-form', body )
                .then( res => this.setState({ sent : true }) )
                .catch( err => {
                    this.setState({ error : true });
                    console.error('err : ', err);
                });
        };

        !condition && !condition2 ? send() : this.setState({ fields }, send );

    }

    contactSuccessMessage(){
        return (
            <div className="col-12 contact-success">
                <h3 className="heading-two">Thank you for your submission</h3>
                <p className="body-copy">Someone from our team will be in touch with you.</p>
                <Anchor path='/' anchorClass='theme-button' internal>
                    Go Home
                </Anchor>
            </div>
        );
    }

    contactErrorMessage(){
        return (
            <div className="col-12 contact-success">
                <h3 className="heading-two">There was an error sending your query</h3>
                <p className="body-copy">Oops, it looks like you've encountered an issue when submitting your message. Please try again.</p>
                <Anchor path='/' anchorClass='theme-button' internal>
                    Go Home
                </Anchor>
            </div>
        );
    }

    content(){
        if( !this.state.sent && !this.state.error ){
            return (
                <form key='form' className="contact-form" ref={ this.formRef }>
                    { this.buildFields() }
                    <div className="col-12 form-group button">
                        <button className="theme-button" type="button" value="button" onClick={() => this.submit()}>Send message</button>
                    </div>
                </form>
            );
        };
        if( this.state.error ){ return this.contactErrorMessage() };
        return this.contactSuccessMessage();
    }

    render() {
        return (
            <div className="portal-page-wrapper contact-page theme-page-whole-blue">
                <div className="image" style={{ backgroundImage: 'url(/images/contact.jpg)' }}></div>
                <div className="container inner-content">
                    <div className="row">
                        <div key='heading' className="col-12 heading">
                            <h1 className="heading-main">Contact Us</h1>
                            <p className="body-copy">Want to get in touch? We'd love to hear from you. Please enter your details below and we will contact you shortly.</p>
                        </div>
                        { this.content() }
                    </div>
                </div>
            </div>
        );
    };
};




// WEBPACK FOOTER //
// src/client/components/site/pages/ContactPage.js